import type { ScenePublicApi } from "@/layers/Compositor";
import type { GuiTimeZone, WmsLayer } from "@mm/metx-workbench.meteomatics.com";
import { BinaryColormapLayerImpl } from "./BinaryColormapLayerImpl";

// Globe-safe binary renderer using Mapbox 3D custom layer mode.
// Technique: Texture-Sampling / Surface Draping (via renderToTile in the base class).
export class BinaryColormapFallbackLayerImpl extends BinaryColormapLayerImpl {
  constructor(uid: number, props: WmsLayer, scene: ScenePublicApi, timezone: GuiTimeZone) {
    super(uid, props, scene, timezone, { renderingMode: "3d" });
  }
}
